export const teamData = [
  {
    id: 'sarang-dave',
    name: 'CA Sarang Mahesh Dave',
    title: 'Founder',
    qualifications: 'FCA, M.Com., DISA',
    image: '/images/sarang_dave.webp',
    bio: 'CA Sarang Dave, the founder of the firm, is a fellow Chartered Accountant. Mr. Sarang began his professional career in 2015. He has also completed DISA (Diploma in Information System Audit), a Post Qualification Course from ICAI. From the very beginning, his focus has always been on professional excellence through hard work, dedication, and expertise. Presently he has been looking after the Litigation Services in Assessment & Appeal Proceedings in Income Tax and GST Matters, Project Finance Services, Virtual CFO Services, Company Law Matters, RERA Consultancy, and Government Subsidies related consultancy. With his commitment towards work and dynamism, he looks forward to directing the team at Dave & Associates towards the achievement of new heights.',
    linkedin: 'https://www.linkedin.com/in/ca-sarang-dave-888b0269/',
    specializations: [
      'Tax Litigation & Appeal Proceedings',
      'Project Finance Services',
      'Virtual CFO Services',
      'RERA Consultancy',
      'Government Subsidies'
    ]
  },
  {
    id: 'stuti-bhatt',
    name: 'CA Stuti Rajiv Bhatt',
    title: 'Principal Consultant',
    qualifications: 'ACA, B.Com.',
    image: '/images/stuti.webp',
    bio: 'CA Stuti Bhatt has been associated with the organization as a Principal Consultant. Ms. Stuti is a dynamic, young and meticulous professional who handles diversified work portfolio in the firm. Currently she has been looking after Statutory & Tax Audits, GST & Income Tax Compliance and Reporting Work, Outsourced Bookkeeping Services and Advisory Services. She leads the team from the front, establishing cogent practices of team management. With her professional experience and commitment towards work, she plays a vital role in maintaining the competence and professional excellence of the firm as a whole.',
    linkedin: 'https://www.linkedin.com/in/ca-stuti-bhatt-b32323305/',
    specializations: [
      'Statutory & Tax Audits',
      'GST & Income Tax Compliance',
      'Outsourced Bookkeeping Services',
      'Advisory Services',
      'Team Management'
    ]
  }
];
